let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([load("ffQaD"), load("kvRbA"), load("klfge")]).then(() => parcelRequire('a9ULj'));